import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Box, Button } from "@mui/material";

export default function RedirectButton({
	url,
	title = "Start",
	disabled = false,
	handleClick = () => {},
	loading = false,
	loadingMessage = "Submitting..",
	removeSpacer = false,
}) {
	const navigate = useNavigate();
	const location = useLocation();
	const publicUrl = process.env.PUBLIC_URL;

	const handleProceed = () => {
		handleClick();
		if (url) return navigate(`${publicUrl}${url}${location?.search || ""}`);
	};

	return (
		<React.Fragment>
			{/* Add space for absolute position */}
			{!removeSpacer && (
				<Box className="pos-abs-spacer" sx={{ mb: 5 }}></Box>
			)}
			<Box
				component="div"
				className="redirect-button footer-button-container"
			>
				<Button
					size="large"
					variant="contained"
					sx={{ mt: 1, borderRadius: "20px", p: "5px 25px" }}
					onClick={handleProceed}
					disabled={disabled || loading}
				>
					{loading ? loadingMessage : title}
				</Button>
			</Box>
		</React.Fragment>
	);
}
